import { render } from "./Compte.vue?vue&type=template&id=705a8342&scoped=true"
import script from "./Compte.vue?vue&type=script&lang=js"
export * from "./Compte.vue?vue&type=script&lang=js"

import "./Compte.vue?vue&type=style&index=0&id=705a8342&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705a8342"]])

export default __exports__